module.exports = "<mat-card class=\"messageBox\" id=\"messageBoxId\" *ngIf=\"messageText\">{{showTextAlertBox()}}</mat-card>"